import { useState } from "react";

const CONSENT_COOKIE = "cookie_consent";
const CONSENT_EVENT = "hirsch-consent-updated";

export const getCookieConsent = () => {
    const consentCookie = document.cookie
        .split("; ")
        .find((cookie) => cookie.startsWith(`${CONSENT_COOKIE}=`));

    if (!consentCookie) return { analytics: false, marketing: false };

    try {
        return JSON.parse(decodeURIComponent(consentCookie.split("=")[1]));
    } catch {
        return { analytics: false, marketing: false };
    }
};

const saveCookieConsent = (consent) => {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 1);
    document.cookie = `${CONSENT_COOKIE}=${encodeURIComponent(JSON.stringify(consent))}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    window.dispatchEvent(new Event(CONSENT_EVENT));
};

export { CONSENT_EVENT };

function CookieBanner() {
    const [isVisible, setIsVisible] = useState(() => !document.cookie.includes(`${CONSENT_COOKIE}=`));
    const [analytics, setAnalytics] = useState(false);
    const [marketing, setMarketing] = useState(false);

    const saveSelection = (selection) => {
        saveCookieConsent(selection);
        setIsVisible(false);
    };

    const openSettings = () => {
        const savedConsent = getCookieConsent();
        setAnalytics(Boolean(savedConsent.analytics));
        setMarketing(Boolean(savedConsent.marketing));
        setIsVisible(true);
    };

    if (!isVisible) {
        return (
            <button
                aria-label="Cookie-Einstellungen öffnen"
                className="fixed bottom-4 left-4 z-[9999] rounded bg-gray-900 px-3 py-2 text-xs font-semibold text-white shadow-lg hover:bg-gray-700"
                onClick={openSettings}
                type="button"
            >
                Cookie-Einstellungen
            </button>
        );
    }

    return (
        <section className="fixed bottom-0 left-0 right-0 z-[9999] bg-gray-900 text-white shadow-lg" aria-label="Cookie-Einstellungen">
            <div className="mx-auto max-w-screen-xl px-6 py-5">
                <p className="text-sm leading-relaxed text-gray-200">
                    <span className="font-semibold text-pink-400">Cookie-Einstellungen: </span>
                    Notwendige Cookies ermöglichen den Warenkorb und die Bestellung. Mit Ihrer Einwilligung verwenden wir Google Analytics zur Reichweitenmessung und Google Ads zur Messung von Bestellungen. Details finden Sie in unserer{" "}
                    <a className="font-semibold text-pink-300 underline hover:text-pink-200" href="https://hirsch-group.de/datenschutz">
                        Datenschutzerklärung
                    </a>.
                </p>
                <div className="mt-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                    <div className="flex flex-col gap-2 sm:flex-row sm:gap-6 text-sm">
                        <label className="flex items-center gap-2 text-gray-300">
                            <input checked disabled type="checkbox" />
                            Notwendig
                        </label>
                        <label className="flex items-center gap-2">
                            <input checked={analytics} onChange={(event) => setAnalytics(event.target.checked)} type="checkbox" />
                            Statistik (Google Analytics)
                        </label>
                        <label className="flex items-center gap-2">
                            <input checked={marketing} onChange={(event) => setMarketing(event.target.checked)} type="checkbox" />
                            Marketing (Google Ads)
                        </label>
                    </div>
                    <div className="flex flex-wrap gap-3">
                        <button className="px-4 py-2 text-sm font-semibold text-white underline" onClick={() => saveSelection({ analytics: false, marketing: false })} type="button">
                            Nur notwendige
                        </button>
                        <button className="rounded bg-pink-400 px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-pink-500" onClick={() => saveSelection({ analytics, marketing })} type="button">
                            Auswahl speichern
                        </button>
                        <button className="rounded bg-pink-600 px-4 py-2 text-sm font-semibold text-white hover:bg-pink-700" onClick={() => saveSelection({ analytics: true, marketing: true })} type="button">
                            Alle akzeptieren
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CookieBanner;
